import { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { lineLogin, lineLinkAccount } from '../../services/auth/line.service'
import { login } from '../../contexts/Auth'
import LoginPage from '../LoginPage'

function LineCallback() {
  const [socialLogin, setSocialLogin] = useState(null)
  const search = useLocation().search
  const history = useHistory()
  const isProcessingRef = useRef(false)

  useEffect(() => {
    // Prevent duplicate API calls (LINE codes are single-use only)
    if (isProcessingRef.current) return

    const urlParams = new URLSearchParams(search)
    const code = urlParams.get('code')
    const error = urlParams.get('error')
    const errorDescription = urlParams.get('error_description')
    const friendshipStatusChanged = urlParams.get('friendship_status_changed')

    // Handle LINE OAuth errors
    if (error) {
      console.error('LINE OAuth Error:', error, errorDescription)
      alert(`LINE login failed: ${errorDescription || error}`)
      history.replace('/login')
      return
    }

    if (code) {
      isProcessingRef.current = true

      // Check if this is a LINE linking flow (not a normal login)
      const linkUserId = localStorage.getItem('lineLinkUserId')

      if (linkUserId) {
        // This is a linking flow - link LINE account to existing user
        localStorage.removeItem('lineLinkUserId')

        lineLinkAccount(code, parseInt(linkUserId, 10))
          .then(async (result: any) => {
            console.log('LINE account linked successfully', result)

            // Login the user with the returned token
            if (result.accessToken && result.userData) {
              await login(result.accessToken, result.userData, () => {
                const postLoginRedirect = localStorage.getItem('postLoginRedirect')
                if (postLoginRedirect) {
                  localStorage.removeItem('postLoginRedirect')
                  history.replace(postLoginRedirect)
                } else {
                  history.replace('/submission')
                }
              })
            } else {
              throw new Error('Invalid response from LINE link API')
            }
          })
          .catch((error) => {
            console.error('lineLinkError', error)
            const errorMessage =
              typeof error === 'string'
                ? error
                : error?.response?.data?.message || error?.message || 'LINE linking failed'
            alert(errorMessage)
            isProcessingRef.current = false
            history.replace('/submission')
          })
      } else {
        // Normal LINE login flow
        lineLogin(code)
          .then(async (result: any) => {
            // Add friendship status to the result if available
            if (friendshipStatusChanged !== null) {
              result.friendshipStatusChanged = friendshipStatusChanged === 'true'
            }
            setSocialLogin(result)
          })
          .catch((error) => {
            console.error('lineLoginError', error)
            const errorMessage =
              error?.response?.data?.message || error?.message || 'LINE login failed'
            alert(errorMessage)
            isProcessingRef.current = false // Reset on error to allow retry
            history.replace('/login')
          })
      }
    }
  }, [])

  return socialLogin ? <LoginPage socialLogin={socialLogin} channel="LINE" /> : <div></div>
}

export default LineCallback
